import { EMPTY, merge, of, Subject } from 'rxjs';
import { distinctUntilChanged, finalize, switchMap, tap } from 'rxjs/operators';

export function dynamicMergeMap(project, concurrency$) {
    return source$ => {
        let concurrency = 0;
        let backlog = [];
        let nextProcessId = 1;
        let processing = new Map();
        let updateConcurrency$ = concurrency$.pipe(
            distinctUntilChanged(),
            switchMap(c => {
                concurrency = c;
                checkBacklog();
                return EMPTY;
            }),
        );
        let fillBacklog$ = source$.pipe(
            switchMap(item => {
                backlog.push(item);
                checkBacklog();
                return EMPTY;
            }),
        );
        let emitter$ = new Subject();
        return merge(emitter$, updateConcurrency$, fillBacklog$).pipe(
            finalize(() => {
                for (let pId of [...processing.keys()]) {
                    let sub = processing.get(pId);
                    sub.unsubscribe();
                }
            }),
        );

        function checkBacklog() {
            if (backlog.length === 0 || processing.size >= concurrency) {
                return;
            }
            let item = backlog[0];
            backlog.splice(0, 1);
            let item$ = project(item);
            let processId = nextProcessId++;
            let completed = false;
            let sub = item$.subscribe({
                next: evt => emitter$.next(evt),
                error: err => emitter$.error(err),
                complete: () => {
                    completed = true;
                    processing.delete(processId);
                    checkBacklog();
                },
            });
            if (!completed) {
                processing.set(processId, sub);
            }
        }
    };
}
